<script>
import * as Vue from 'vue';
import { constants } from './dnd';
import { getTagProps, validateTagProp } from './utils';

const wrapChild = (createElement, ctx) => {
    const tagProps = getTagProps(ctx, constants.wrapperClass);
    return createElement(tagProps.value, Object.assign({}, tagProps.props), ctx.$slots.default && ctx.$slots.default());
};

export default {
    name: 'PtSortableDraggable',

    props: {
        tag: {
            validator: validateTagProp,
            default: 'div',
        },
    },

    render() {
        return wrapChild(Vue.h, this);
    },
};
</script>
